import { useMemo } from "react";

import dayjs from "dayjs";
import { useSelector } from "react-redux";

import { Trans } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import WidgetBanner from "app/components/WidgetBanner/WidgetBanner";
import { translate } from "app/filters/i18nFilter";
import Change from "app/pages/benchmark-tracker/components/Report/MetricElements/RankingWidget/Change/Change";
import { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";
import { selectAudienceReachAutoDuration } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";

import * as SC from "./styles";

type HeaderSchema = {
    title: string;
    tooltip: string;
    change: string;
    value: string;
    isIncreasing: boolean;
    isNotChanged: boolean;
    onOpenModal: () => void;
    isLoading: boolean;
    hasBanner?: boolean;
};

const Header = ({
    title,
    tooltip,
    value,
    change,
    isIncreasing,
    isNotChanged,
    hasBanner,
    onOpenModal,
    isLoading,
}: HeaderSchema) => {
    const audienceReachAutoDuration = useSelector(selectAudienceReachAutoDuration);
    const date = useMemo(() => dayjs(audienceReachAutoDuration).format("MMMM YYYY"), [audienceReachAutoDuration]);

    return (
        <SC.HeaderContainer>
            <Change
                isIncreasing={isIncreasing}
                isNotChanged={isNotChanged}
                value={value}
                change={change}
                title={title}
                tooltip={tooltip}
                granularity={BenchmarkGranularity.MONTHLY}
                isLoading={isLoading}
            />

            <Flex gap="8px">
                {hasBanner && !isLoading ? (
                    <WidgetBanner
                        title={
                            <Trans
                                i18nKey="benchmark.report.metric.header.banner"
                                values={{ date }}
                                components={{ strong: <strong /> }}
                            />
                        }
                    />
                ) : null}
                <Button
                    type="flat"
                    onClick={onOpenModal}
                    isDisabled={isLoading}
                    dataAutomation="bt-audience-reach-cta"
                >
                    {translate("bt.report.metric.btn.see_all_competitors.text")}
                </Button>
            </Flex>
        </SC.HeaderContainer>
    );
};

export default Header;
